import state from './moduleCurriculumState'
import mutations from './moduleCurriculumMutations'
import actions from './moduleCurriculumActions'
import getters from './moduleCurriculumGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}